import clsx from 'clsx';
import React from 'react';
import { ConfirmButton } from '../../../styling/Styles';

const KickedOutMessage = (props) => {

    const{
        displayKickedOutMessage,
        setDisplayKickedOutMessage
    } = props

    return( 
            <div style={displayKickedOutMessage=== false ? {display: 'none'}: null}>
                <div style={{height: '100vh', width: '100vw', backgroundColor: 'white', zIndex: 1000, position: 'absolute', top: 0, display: 'flex', alignItems: 'center'}}>
                    
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center',width: '100%', position: 'absolute', top: '22%'}}>
                        <img alt='blueSadFace' src='/images/General/blue_sad_face.png' style={{width: '12%'}} />
                        <span style ={{fontSize: '1.4rem',fontWeight: 'bold', color: '#12416b'}}>You have been kicked out of this project</span>
                        <span style={{padding: '0.6vw',fontSize: '1vw', color: '#0c4d82'}}>You can not have access to this project </span>
                        <span style={{padding: '0.6vw'}}> 
                            <ConfirmButton onClick={ () => setDisplayKickedOutMessage(false)}> 
                                <i className={clsx('fas', 'fa-arrow-left')}/>
                                &nbsp;&nbsp;
                                Go back
                            </ConfirmButton></span>
                    </div>
                </div>
            </div>
    )

}

export default KickedOutMessage;